import { useMutation } from "react-query";
import { chatRoomApi } from "@/react/api";

export const useChatRoomParticipant = (chatRoomUuid: any) =>
  useMutation(() => chatRoomApi.getChatRoomCurrentParticipant(chatRoomUuid), {
    mutationKey: ["chatroom", "participant", chatRoomUuid],
  });
